export default "__VITE_ASSET__BMtKipVU__"